import { Map as ImmutableMap } from 'immutable';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { ReauthDialogProps } from './index';

export const REAUTHENTICATION_DIALOG = 'REAUTHENTICATION_DIALOG';
export const getReauthDialogId = (institutionLoginId?: string) => {
  return `${REAUTHENTICATION_DIALOG}_${institutionLoginId || ''}`;
};

export const showReauthenticationDialog = (props: ReauthDialogProps) => {
  // Only show dialog if reauthV2 feature flag is enabled
  const featureFlags = featureFlagsSelectors.dangerouslyUseFeatureFlags();
  if (!featureFlags?.get('reauthV2')) {
    return;
  }

  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: REAUTHENTICATION_DIALOG,
        id: getReauthDialogId(props.institutionLoginId),
        props: ImmutableMap(props),
      }),
    ),
  );
};

export default showReauthenticationDialog;
